import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#D80027",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "m16.444 8.044-.848 3.027-2.545-.47-1.638-3.377-4.426 1.57-.349-.983-1.158-.143.873 2.459 3.045-.779.866 2.439-2.106 3.107 3.573 3.047-.677.794.455 1.074 1.693-1.985-2.197-2.248 1.68-1.969 3.743.27.852-4.618 1.027.19.702-.931z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }